<template>
	<div :class="['webinars']" id="webinars">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'Webinars',
	}
</script> 
